import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {RecipeService, OrderFields, HtmlHelper} from '../shared/shared.module';
import {SelectItem} from 'primeng/components/common/selectitem';

@Component({
  selector: 'app-recipes-sortings',
  templateUrl: './recipes-sortings.component.html',
  styleUrls: ['./recipes-sortings.component.scss']
})
export class RecipesSortingsComponent implements OnInit {
  constructor(private recipeService: RecipeService) { }
  orderFields: SelectItem[] = OrderFields.fields;
  selectedOrderField: SelectItem = null;
  orderDirection: boolean;
  isMobile = false;
  windowWidth: number = window.innerWidth;
  @Output() sortingCheck = new EventEmitter();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit() {
    this.recipeService.sortHashObs.subscribe( x => {
      if (x === 1) {
        this.orderDirection = this.recipeService.sortHashDirection;
        this.selectedOrderField = this.recipeService.selectedField;
        this.recipeService.activateSort();
      }
    });

    this.recipeService.getStatusActivatingSort().subscribe(sortStatus => {
      if (!sortStatus) {
        this.selectedOrderField = null;
        this.orderDirection = null;
      }
    });

    this.recipeService.getFilterState().subscribe(x => {
      if (x !== null) {
        this.orderDirection = null;
        this.setOrderDirection();
        this.selectedOrderField = null;
      }
    });
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  onOrderChange(fieldChanged = false) {
    if (fieldChanged) {
      this.orderDirection = true;
    }
    this.setOrderDirection();
    if (!this.isMobile) {
      this.recipeService.get();
      this.recipeService.getShort();
    } else {
      this.sortingCheck.emit();
    }
  }

  private setOrderDirection() {
    const filterField = 'Sort';
    if (this.selectedOrderField) {
      this.recipeService.activateSort();
      const field = this.selectedOrderField.value;
      if (this.orderDirection == null) {
        this.recipeService.setFilter(filterField, undefined);
        return;
      }
      const direction = this.orderDirection ? 'asc' : 'desc';
      this.isSortCostWeight(field) ?
        this.recipeService.setFilter(filterField, this.orderDirection ? field : `${field} desc`) :
        this.recipeService.setFilter(filterField, [field, direction].join(' '));
    }
    return;
  }

  private isSortCostWeight = (field: string): boolean => field === 'cost/CalculationWeight';

}



// WEBPACK FOOTER //
// ./src/app/recipes-sortings/recipes-sortings.component.ts